var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'c-project-status-badge d-inline-flex px-2 py-1 rounded-5',
    'is-' + _vm.status.status ]},[(_vm.status.active)?_c('img',{staticClass:"mr-2",attrs:{"src":require("@/assets/icons/green-circle.svg")}}):_vm._e(),_c('span',{staticClass:"p-12-b display-status"},[_vm._v(_vm._s(_vm.status.displayStatus))])])}
var staticRenderFns = []

export { render, staticRenderFns }